module.exports = __webpack_public_path__ + "static/media/zoomIn.a2805e15.svg";